import Layout from "@/Layouts/index.vue";
import Vue from "vue";
import VueRouter from "vue-router";
import Routers from "./modules/routers";
Vue.use(VueRouter);

const createRouter = () =>
  new VueRouter({
    mode: "history", // Disabled due to Github Pages doesn'tmode修改为hash support this, enable this if you need.
    scrollBehavior: (to, from, savedPosition) => {
      // console.log("router-change", to, from, savedPosition);
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    },
    base: process.env.BASE_URL,
    routes: [
      {
        path: "",
        name: "Layout",
        // redirect: "",
        meta: { hidden: false, parentCom: "Layout2" },
        component: Layout,
        children: [...Routers],
      },
      {
        path: "*",
        name: "Other",
        redirect: "",
        meta: { hidden: true },
      },
    ],
  });
const router = createRouter();

export default router;
